import React, { useState, useEffect, useRef } from "react";
import { observer } from "mobx-react-lite";
import {
  Button,
  Navbar,
  Alignment,
  NavbarDivider,
  EditableText,
  Popover,
} from "@blueprintjs/core";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { searchByHeader, loginModal } from "../Redux/authAction";
import MdcCloudAlert from "@meronex/icons/mdc/MdcCloudAlert";
import MdcCloudCheck from "@meronex/icons/mdc/MdcCloudCheck";
import MdcCloudSync from "@meronex/icons/mdc/MdcCloudSync";
import styled from "polotno/utils/styled";
import { auth } from "../FirebaseConfig";
import "../components/Styles.css";
import login from "../assets/home/gmail.jpg";
import {
  signInWithPopup,
  GoogleAuthProvider,
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  updateProfile,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";

import { useProject } from "../project";
import { forEveryChild } from "polotno/model/group-model";

import { FileMenu } from "./file-menu";
import { DownloadButton } from "./download-button";
import { UserMenu } from "./user-menu";
import { CloudWarning } from "../cloud-warning";
import Goo from "../assets/icons/Picture1.png";
import { useSelector, useDispatch } from "react-redux";
import { loginUser, logoutUser, language } from "../Redux/authAction";
import logo from "../assets/resume/logo.png";
import { NavLink, useNavigate } from "react-router-dom";
import { FaDoorClosed, FaDownload } from "react-icons/fa";
import DeveloperButton from "./developer-button";
import api from '../config/api';

// Get Category
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "clamp(750px,100%,300px)",
  height: "600px",
  bgcolor: "background.paper",
  border: "0px solid #000",
  boxShadow: 24,
  p: 4,
};

const NavbarContainer = styled("div")`
  white-space: nowrap;

  @media screen and (max-width: 500px) {
    overflow-x: auto;
    overflow-y: hidden;
    max-width: 100vw;
  }
`;

const NavInner = styled("div")`
  @media screen and (max-width: 500px) {
    display: flex;
  }
`;

const PlayButton = observer(({ store }) => {
  //-----------------------------------------------------------------------------





  //------------------------------------------------------------------------------

  let hasAnimations = false;
  forEveryChild({ children: store.pages }, (child) => {
    const hasAnim = child.animations?.find((el) => el.enabled);
    if (hasAnim) {
      hasAnimations = true;
    }
  });
  if (!hasAnimations) {
    return null;
  }


 const  submit = () => {

    confirmAlert({
      title: 'Confirm to submit',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Yes',
          onClick: () => alert('Click Yes')
        },
        {
          label: 'No',
          onClick: () => alert('Click No')
        }
      ]
    });
  };
  return (
    <Button className="mr-[20px] rounded-lg px-2 py-2 text-center"
    style={{fontWeight:"600"}}
      icon={store.isPlaying ? "pause" : "play"}
      onClick={() => {
        if (store.isPlaying) {
          store.stop();
        } else {
          store.play();
        }
      }}



      // onClick={submit }
      // style={{
      //   marginRight: "10px",
      // }}
    >
      Preview
    </Button>
  );
});
const Status = observer(({ project }) => {
  const Icon = !project.cloudEnabled
    ? MdcCloudAlert
    : project.status === "saved"
    ? MdcCloudCheck
    : MdcCloudSync;
  return (
    <Popover
      content={
        <div style={{ padding: "10px", maxWidth: "300px" }}>
          {!project.cloudEnabled && (
            <CloudWarning style={{ padding: "10px" }} />
          )}
          {project.cloudEnabled && project.status === "saved" && (
            <>
              You data is saved with{" "}
              <a href="https://puter.com" target="_blank">
                Puter.com
              </a>
            </>
          )}
          {project.cloudEnabled &&
            (project.status === "saving" || project.status === "has-changes") &&
            "Saving..."}
        </div>
      }
      interactionKind="hover"
    >
      <div style={{ padding: "0 5px" }}>
        <Icon className="bp5-icon" style={{ fontSize: "25px", opacity: 0.8 }} />
      </div>
    </Popover>
  );
});

export default observer(({ store }) => {

  const project = useProject();


  const handleGoogleLogin = () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
      .then((result) => {
        const user = result.user;
        setGoogle(user);
        const { displayName, email, uid } = user;
        dispatch(loginUser({ displayName, email, uid }));

        handleCloseModel();
        handleClose();
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        const email = error.customData.email;
        const credential = GoogleAuthProvider.credentialFromError(error);
      });
  };
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (result) => {
      if (result) {
        const { displayName, email } = result;
      } 
    });
    return () => unsubscribe();
  }, []);

  const isLang = useSelector((state) => state.authReducer.lang);
  const userID = useSelector((state) => state.authReducer.uid);
  const userName = useSelector((state) => state.authReducer.name);
  const emails = useSelector((state) => state.authReducer.email);
  const loginModalValue = useSelector((state) => state.authReducer.loginModal);

  const handleOpen = () => {
    dispatch(loginModal(true));
    setOpenModel(true);

  };

  const handelOpenModel = () => {
    dispatch(loginModal(false));
    setOpenModel(false);
  };
  const handleClose = () => {
    dispatch(loginModal(false));
    dispatch(loginModal(false));
  };
  const handleCloseModel = () => setOpenModel(false);

  useEffect(() => {
    const handleReload = () => {
      if (performance.navigation.type === 1) {
        isAuthenticated
          ? dispatch(loginModal(true))
          : dispatch(loginModal(true));
      }
    };
    window.addEventListener("load", handleReload);
    return () => {
      window.removeEventListener("load", handleReload);
    };
  }, []);
  // Custom
  const handleSignup = async () => {
    try {
      if (name && email && password) {
        const userCredential = await createUserWithEmailAndPassword(
          auth,
          email,
          password
        );
        await updateProfile(userCredential.user, {
          displayName: name,
        });
        setSnackbarSeverity("success");
        setSnackbarMessage("Signup successful!");
        setSnackbarOpen(true);
    
        handleCloseModel();
      } else {
        setSnackbarSeverity("error");
        setSnackbarMessage("Please enter valid name, email, and password.");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error during signup:", error);
      let errorMessage = "Unexpected error occurred.";
      if (error.code === "auth/operation-not-allowed") {
        errorMessage =
          "Firebase authentication operation not allowed. Check Firebase Console settings.";
      }
      setSnackbarSeverity("error");
      setSnackbarMessage(errorMessage);
      setSnackbarOpen(true);
    }
  };
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbarOpen(false);
  };
  useEffect(() => {
    auth.onAuthStateChanged((user) => {});
  }, []);
  
  const handleLogin = async () => {
   
    try {
      if (emaill && password) {
  
        const response = await fetch(api.getUrl(api.ENDPOINTS.GET_SUBSCRIPTION_DATA), {
          method: "POST",
          body: formData,
        });
  
        if (!response.ok) {
          throw new Error("Failed to fetch subscription data.");
        }
  
        const data = await response.json();
  
        if (data.status === "success" && data.data.length > 0) {
          const subscription = data.data[0]; // Get the first subscription record
          const { packageid, status } = subscription;
          const temp_pkgid = useSelector((state) => state.authReducer.temp_pkgid); // Moved outside
        
          // Dispatch login details to Redux
          dispatch(loginUser({ displayName, email, uid, packageid, status , temp_pkgid})); // Fix: Using 'email' here
  
          console.log("The ID from redux name is  ------------------------ >  :" + packageidid);
          console.log("The UID from redux name is  ------------------------ >  :" + uid);
          // Show success snackbar
          setSnackbarSeverity("success");
          setSnackbarMessage(isLang === "arabic" ? "تسجيل الدخول بنجاح!" : "Login successful!");
          setSnackbarOpen(true);
  
          // Close login modal
          dispatch(loginModal(false));
          handleCloseModel();
        } else {
          // If no subscription found, show an error
          setSnackbarSeverity("error");
          setSnackbarMessage(isLang === "arabic" ? "لم يتم العثور على اشتراك." : "No subscription found.");
  
          const subscription = data.data[0]; // Get the first subscription record
          const { packageid, status } = subscription;
        
          const temp_pkgid = useSelector((state) => state.authReducer.temp_pkgid); // Moved outside
        
          dispatch(loginUser({ displayName, email, uid,packageid,status, temp_pkgid}));
  
          console.log("The ID from redux name is  ------------in case of no data------------ >  :" + packageidid);
          setSnackbarOpen(true);
          handleCloseModel();
        }
      } else {
        // Handle the case where email or password is missing
      }
    } catch (error) {
      // Handle the error
    }
  };

  const handlesignout = () => {
    dispatch(logoutUser());
    window.location.href = "";
  };

  //--------------------------------------------------------------------------------------

  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );


  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [logEmail, setLogEmail] = useState("");
  const [logName, setLogName] = useState("");
  const [logPassword, setLogPassword] = useState("");
  const [openModel, setOpenModel] = useState(isAuthenticated ? false : true);
  const [google, setGoogle] = useState(null);
  const [categories, setCategories] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const developerrole = useSelector((state) => state.authReducer.developerrole);

 



  return (
     
    <>
      
      <NavbarContainer className="bg-gradient-to-r from-purple-700 via-purple-700 to-purple-700"
      >
        <NavInner>
          <Navbar.Group align={Alignment.LEFT}>
            <FileMenu store={store} project={project} />

            {/* <div
            style={{
              paddingLeft: '20px',
              maxWidth: '200px',
            }}
          >
            <EditableText
              value={window.project.name}
              placeholder="Design name"
              onChange={(name) => {
                window.project.name = name;
                window.project.requestSave();
              }}
            />
          </div> */}
          </Navbar.Group>


          <Navbar.Group align={Alignment.RIGHT}>
            {/* <Status project={project} /> */}
            {/* <NavbarDivider /> */}
            <PlayButton store={store} />
            {isAuthenticated ? (<>
            {developerrole === "Designer"?(
              <>
               <DeveloperButton store={store}/>
              </>
            ):(
              <DownloadButton store={store} />
            )
            }
              </>
            ) : (
              <div className=" flex">
                {developerrole==="Designer"?(
                  <>
                  <DeveloperButton store={store}/>
                  </>
                ):(<>
                 <Button
                  onClick={handleOpen}
                  className=" bg-slate-400 text-blue-500 font-semibold text-md mr-3 w-[100px] border-lg border-white "
                  type="button"
                  style={{
                    borderRadius: "10px",
                    borderColor: "white",
                  }}
                  value="Login Please"
                >
                  Sign In{" "}
                </Button>
                </>)}
                
               

                <button
  onClick={handleOpen}
  className="bg-purple-500 p-2 text-white font-semibold text-md mr-3 hover:bg-gradient-to-r hover:from-purple-900 hover:via-purple-900 hover:to-purple-900"
  type="button"
  style={{
    fontSize: "15px",
    borderRadius: "10px",
    color: "white",
    
  }}
  value="Login Please"
>
  <span className="flex flex-row gap-2 px-2 justify-center items-center">
    <span className="text-[14px]">
    <FaDownload />
    </span>
    Download{" "}
  </span>
</button>


              </div>
            )}
            {/* { <DownloadButton/>} */}
            {/* <UserMenu store={store} project={project} /> */}
            {/* <NavbarHeading>Polotno Studio</NavbarHeading> */}
          </Navbar.Group>
        </NavInner>
      </NavbarContainer>

      <Modal
        open={ isAuthenticated ? false : loginModalValue  }
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style} className="rounded-lg text-[#262b33]">

        <div className=" flex items-end justify-end" onClick={handleClose}>
              <p className="text-black p-1 text-lgs font-semibold hover:text-red-700" style={{ fontFamily:"poppins", fontSize:"16px"}}> X </p>
            </div>
          <div className="flex ">
           
            <div className="w-[50%] h-[70vh] flex flex-col  gap-4 mr-7 ml-2">
             
                {isLang === "eng" ? 
                 <p className="mb-[30px] mt-[20px] text-[24px] font-[700] relative -left-3"> Sign In </p> :
                 <p className="mb-[30px] mt-[20px] text-[24px] font-[700] relative -left-3"> Sign Up </p> 
              }


              {isLang === "eng" ?  "":<div>
                <p>Display Name:</p>
                <input
                  type="text"
                  placeholder="Full Name"
                  value={logName}
                  onChange={(e) => setLogName(e.target.value)}
                  className="p-2 border-2 rounded focus:outline-blue-500 w-full bg-slate-50"
                />
              </div>
              }
              
              <div>
                <p>Email:</p>
                <input
                  type="text"
                  placeholder="Email"
                  value={logEmail}
                  onChange={(e) => setLogEmail(e.target.value)}
                  className="p-2 border-2 rounded focus:outline-blue-500 w-full bg-slate-50"
                />
              </div>
              <div className="">
                <p>Password</p>
                <input
                  type="password"
                  placeholder="Password"
                  value={logPassword}
                  onChange={(e) => setLogPassword(e.target.value)}
                  className="p-2 border-2 rounded focus:outline-blue-500 w-full bg-slate-50"
                />
              </div>
             {isLang == "eng" ?  <button
                onClick={handleLogin}
                className="bg-gradient-to-r from-[#4c76cf] to-[#552ab8] px-7 py-3 rounded-md text-white text-[16px] font-[600] cursor-pointer ">
                Login
              </button> :
              <button
              onClick={handleSignup}
              className="bg-gradient-to-r from-[#4c76cf] to-[#552ab8] px-7 py-3 rounded-md text-white text-[16px] font-[600] cursor-pointer ">
               SignUp
            </button>}



              <button
                onClick={handleGoogleLogin}
                className="flex items-center bg-white dark:bg-gray-900 border border-gray-300 rounded-lg shadow-md px-6 py-2 text-sm font-medium text-gray-800 dark:text-white hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500" >
                <img src={`${Goo}`} className="h-8" />
                <span>Continue with Google</span>
              </button>
             
             {isLang === "eng" ? 
              <div style={{ display: "flex", gap: "4px" }}>
              <p>Do Not Have an Account: </p>{" "}
              <button
                onClick={() => dispatch(language("arabic"))}
                className="focus:outline-none active:outline-none  text-[#3b603d] font-[600] hover:underline"
              >
                SignUp
              </button>
            </div> :
            
            <div style={{ display: "flex", gap: "4px" }}>
            <p>Already Have an Account : </p>{" "}
            <button
              onClick={() => dispatch(language("eng"))}
              className="focus:outline-none active:outline-none  text-[#3b603d] font-[600] hover:underline"
            >
              {" "}
              Login
            </button>
          </div>
          }
            </div>

            <div className="w-[50%] h-[100%] bg-slate-600 overflow-hidden">
              <img src={`${login}`} className="h-full" alt="" />
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
});
